// import { Button, message, Upload, Image } from "antd";
// import React, { useState, useEffect } from "react";
// import { UploadOutlined } from "@ant-design/icons";
// import { uploadFile, deleteFile } from "react-s3";
// import { s3Config } from "../config/s3Config";
// import { getFileExtension } from "../helper/functions";
// import { uploadToS3 } from "../helper/s3";

// const FileType = [
//     "image/png",
//     "image/jpg",
//     "image/jpeg",
//     "image/avif",
//     "image/webp",
//     "image/gif",
// ];

// const SingleImageUpload = ({
//     fileType = FileType,
//     value,
//     imageType,
//     btnName,
//     onChange,
//     size = 1,
//     isDimension = false,
//     ...props
// }) => {
//     const [file, setFile] = useState([]);

//     const handleImgChange = async (event) => {
//         const { file } = event;
//         setFile([file]);
//         const extension = getFileExtension(file.name);
//         const name = `SOCIALMEDIA_${new Date().getTime()}.${extension}`;

//         const newFile = new File([file], name, { type: file.type });

//         //  await uploadToS3({file:newFile,type:imageType})

//         uploadToS3({ file: newFile, type: imageType })
//             .then((data) => {
//                 console.log("File Upload", newFile, data);
//                 const fileData = {
//                     uid: file.uid,
//                     name: name,
//                     status: "done",
//                     url: data.location,
//                     thumbUrl: data.location,
//                 };
//                 setFile([fileData]);
//                 if (onChange) {
//                     onChange([fileData]);
//                 }
//             })
//             .catch((err) => console.error(err));

//         /*  uploadFile(newFile, s3Config(imageType))
//             .then((data) => {
//               console.log("File Upload", newFile, data);
//               const fileData = {
//                 uid: file.uid,
//                 name: name,
//                 status: "done",
//                 url: data.location,
//                 thumbUrl: data.location,
//               };
//               setFile([fileData]);
//               if (onChange) {
//                 onChange([fileData]);
//               }
//             })
//             .catch((err) => console.error(err)); */

//     };

//     const checkImageDimensions = (file) => {
//         return new Promise((resolve, reject) => {
//             const img = document.createElement("img");

//             img.onload = () => {
//                 if (img.width === 720 && img.height === 480) {
//                     resolve();
//                 } else {
//                     reject(
//                         `Please upload an image with dimensions 720 X 480. uploaded image is ${img.width} X ${img.height}`,
//                     );
//                 }
//             };

//             img.src = URL.createObjectURL(file);
//         });
//     };

//     const beforeUpload = (file) => {
//         if (fileType.includes(file.type)) {

//         } else {
//             message.error("File format is not correct")
//             return false
//         }
//         const isLt2M = file.size / 1024 / 1024 < 5;

//         if (!isLt2M) {
//             message.error(`Image must be smaller than 5 MB!`)
//             return false
//         }
//         return true
//     }

//     const Delete = (filename, imageType) => {
//         deleteFile(filename, s3Config(imageType))
//             .then(response => console.log(response))
//             .catch(err => console.error(err))
//     }

//     const onRemove = (data) => {
//         console.log(data, "Remove", file);
//         Delete(value)
//         setFile([]);
//         if (onChange) {
//             onChange([]);
//         }
//     }

//     useEffect(() => {
//         if (!value) setFile([]);
//     }, [value]);

//     return (
//         <Upload
//             listType="picture"
//             maxCount={1}
//             beforeUpload={beforeUpload}
//             customRequest={handleImgChange}
//             onRemove={onRemove}
//             fileList={file}
//             {...props}
//         >
//             {file && file.length > 0 && file !== "" ? null : (
//                 <Button icon={<UploadOutlined />}>
//                     {" "}
//                     {btnName ? `Upload ${btnName}` : ""}
//                 </Button>
//             )}
//         </Upload>
//     );
// };

// export default SingleImageUpload;

import { Button, Upload as UploadAntd } from "antd";
import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { ShowToast, Severty } from "../helper/toast";
import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import { Upload as UploadIcon } from "lucide-react";

const s3Config = {
  region: "us-east-1",
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/",
  forcePathStyle: true,
};

const s3Client = new S3Client(s3Config);
const SingleImageUpload = ({
  fileType,
  value,
  imageType,
  btnName,
  onChange,
  size = 5,
  width = 600,
  height = 600,
  isDimension = false,
  ...props
}) => {
  const [file, setFile] = useState([]);

  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = document.createElement("img");

      img.onload = () => {
        if (img.width === width && img.height === height) {
          resolve();
        } else {
          reject(
            `Please upload an image with dimensions (${width}X${height}). uploaded image is ${img.width} X ${img.height}`
          );
        }
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const beforeUpload = async (file) => {
    try {
      if (fileType.includes(file.type)) {
      } else {
        ShowToast("File format is not correct", Severty.ERROR);
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < size;

      if (!isLt2M) {
        ShowToast(`Image must be smaller than ${size} MB!`, Severty.ERROR);
        return false;
      }
      return true;
    } catch (err) {
      ShowToast(err, Severty.ERROR);
      return false;
    }
  };

  const onRemove = () => {
    setFile([]);
    if (onChange) {
      onChange("");
    }
  };

  useEffect(() => {
    if (value) {
      setFile([
        {
          uid: "-1",
          name: "uploaded.png",
          status: "done",
          url: typeof value === "string" ? value : value.url,
          thumbUrl: typeof value === "string" ? value : value.thumbUrl,
        },
      ]);
    } else {
      setFile([]);
    }
  }, [value]);

  const uploadFileToS3 = async (file, bucketName) => {
    const key = "aleef/" + imageType + "/" + file.name;

    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      return data;
    } catch (err) {
      throw err;
    }
  };

  const handleImgChange = async ({ file, onSuccess, onError }) => {
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      if (onChange) onChange(fileData.url); // single file, not array
      onSuccess("ok");
    } catch (err) {
      console.error(err);
      if (onError) onError(err);
    }
  };

  return (
    <UploadAntd
      color="white"
      listType="picture"
      className="main-new-picture-typr"
      maxCount={1}
      beforeUpload={beforeUpload}
      customRequest={handleImgChange}
      onRemove={onRemove}
      fileList={file}
      {...props}
    >
      {file && file.length > 0 && file !== "" ? null : (
        <Button className="main-new-button_upload">
          {" "}
          {btnName ? ` ${btnName}` : ""} <UploadIcon />
        </Button>
      )}
    </UploadAntd>
  );
};

export default SingleImageUpload;
